import { mondayIsoForDateInLocal } from './dashboardDateContext';
import { addDays, parseISODate } from './date';

export type WeekSwipeCommit = 'prev' | 'next' | 'center';

const IGNORE_SELECTOR = 'textarea, input, select, [contenteditable="true"]';

/** 가로 제스처로 주 넘김을 잠그기 전 최소 이동 */
export const WEEK_SWIPE_LOCK_PX = 16;

export function shiftMondayIso(mondayIso: string, weekDelta: number): string {
  return mondayIsoForDateInLocal(addDays(parseISODate(mondayIso), weekDelta * 7));
}

export function isWeekSwipeIgnoreTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  return Boolean(target.closest(IGNORE_SELECTOR));
}

/**
 * 손가락/포인터: 오른쪽(dx>0)이면 이전 주, 왼쪽(dx<0)이면 다음 주.
 * 스크롤/휠: deltaX>0(오른쪽 내용)이면 다음 주.
 */
export function weekSwipeCommitFromDelta(input: {
  delta: number;
  axis: 'pointer' | 'wheel';
  canPrev: boolean;
  canNext: boolean;
}): WeekSwipeCommit {
  const { delta, axis, canPrev, canNext } = input;
  if (!(delta !== 0)) return 'center';
  const toNext = axis === 'pointer' ? delta < 0 : delta > 0;
  if (toNext) return canNext ? 'next' : 'center';
  return canPrev ? 'prev' : 'center';
}
